<div *ngIf="model && fields">
    <div class="container-flex">     
      <div class="row">
       <div class="col-12 col-md-5 col-lg-4">          
        <app-feltliste [formGroup]="formGroup" [fields]="fields" [modell]="model"></app-feltliste>    
        </div>        
      </div>
  </div>
</div>